import styled, { css } from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'

export const activeStyle = css`
  color: ${props => props.theme.palette.neutral.eight};
  background-color: ${({ theme }) => theme.palette.primary.normal};

  &,
  &:hover,
  &:active,
  &:focus {
    color: ${props => props.theme.palette.neutral.eight};
    background-color: ${({ theme }) => theme.palette.primary.normal};
  }

  &::after {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 100%;
    border: ${rem(12)} solid transparent;
    border-top: ${rem(10)} solid ${({ theme }) => theme.palette.primary.normal};
    border-bottom: 0;
    content: "";
  }
`

const OfferNavItem = styled(Clickable)<{ active?: boolean }>`
  padding: ${rem(16)};
  border-left: 1px solid ${({ theme }) => theme.palette.neutral.five};
  font-weight: ${({ theme }) => theme.font.primary.weight.bold};
  position: relative;
  transition: background-color 0.2s, color 0.2s;

  ${mediaQueryUp.tablet} {
    min-width: ${rem(153)};
  }

  &,
  &:active,
  &:focus {
    color: ${({ theme }) => theme.palette.primary.normal};
    background-color: ${props => props.theme.palette.neutral.eight};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral.six};
    color: ${({ theme }) => theme.palette.primary.normal};
  }

  &:last-of-type {
    border-right: 1px solid ${({ theme }) => theme.palette.neutral.five};
  }

  ${({ active }) => active && activeStyle}
`

export default OfferNavItem
